import * as React from 'react';
import { IRedirectCandidate, PropertyHelper, ERedirectCandidateType } from '../../helpers';
import { Search } from '../common/search';
import { Button, ButtonType } from 'office-ui-fabric-react';

interface IProps {
	componentId: string;
	selectedCandidate: IRedirectCandidate;
	onSearchResultClicked: (candidate: IRedirectCandidate) => void;
	updateSearchResults: (searchTerm: string) => void;
	onSearchBlur: () => void;
	redirectCandidateResults: IRedirectCandidate[];
	term: string;
	awaitingResults: boolean;
}

export class RedirectCandidateSearch extends React.Component<IProps, any> {

	public render() {

		let { componentId, selectedCandidate, onSearchResultClicked, redirectCandidateResults, term, onSearchBlur, updateSearchResults, awaitingResults } = this.props;

		return (
			<Search 
				results={ redirectCandidateResults }
				searchTerm={ term }
				labelText={ 'Search for a redirect candidate...' }
				showResultsWithEmptyTerm={ false }
				isCurrentSearchComponent={ true }
				awaitingResults={ awaitingResults }
				debounceDelay={ 250 }
				displayRedirectCandidateItems={ true }
				onResultClick={ (key, item) => {
					onSearchResultClicked(item);
				} }
				onBlur={ onSearchBlur }
				updateResults={ updateSearchResults }
			/>	
		);

	}

}


// WEBPACK FOOTER //
// ./source/ts/components/redirect/redirect-candidate-search.tsx